<template>
    <div>
        <LoadingOverlay :loading="loading" />
        <div v-if="noData" class="no-data-container">
            <p class="no-data-message">No data available</p>
        </div>
        <div v-else>
            <div class="topThreeRewards-box">
                <div class="rewardsBoxes">
                    <div class="position-relative rewardsBox" v-if="FansRankingWeeklyData.length > 1">
                        <img :src='fansRank2_bg' class="fansRank_bgImage fansRank2_bgImage" alt="" />
                        <div class="position-relative rewardsBox-In" @click="redirectProfile(FansRankingWeeklyData[1].user.id, FansRankingWeeklyData[1].user.profile_id, FansRankingWeeklyData[1].user.rich_level)">
                            <div class="rewardsProfile-imageBox">
                                <img :src='ProfileFrame2' class="profile-imgFrame" alt="pf-frame" />
                                <div class="profile-imageBox" v-if="FansRankingWeeklyData.length > 1">
                                    <img class="overlapImg" :src='FansRankingWeeklyData[1].user.profile_images[0].image_name'
                                        alt="User Image" />
                                </div>                                
                            </div>
                            <div class="text-center text-white fansRank_no">No.2</div>
                            <div class="userName-box">
                                <div class="userName" v-if="FansRankingWeeklyData.length > 1">{{ FansRankingWeeklyData[1].user.name }}
                                </div>
                                <div class="beansBox">                                    
                                    <span class="beansValue" v-if="FansRankingWeeklyData.length > 1">
                                        {{ FansRankingWeeklyData[1].total_gift_price }}
                                    </span>
                                    <img :src='diamondIcon' class="diamondIcon" alt="" />
                                </div>
                            </div>
                            <div class="rewards-level" v-if="FansRankingWeeklyData.length > 1">
                                <img :src="getLevelImage(FansRankingWeeklyData[1].user.rich_level)" class="lavelImage" alt="level icon" />
                                <span class="lavel-value">{{ FansRankingWeeklyData[1].user.rich_level }}</span>
                            </div>
                        </div>
                    </div>
                    <div class="position-relative rewardsBox center-rewardsBox" v-if="FansRankingWeeklyData.length > 0">
                        <img :src='fansRank1_bg' class="fansRank_bgImage fansRank1_bgImage" alt="" />
                        <div class="position-relative rewardsBox-In" @click="redirectProfile(FansRankingWeeklyData[0].user.id, FansRankingWeeklyData[0].user.profile_id, FansRankingWeeklyData[0].user.rich_level)">
                            <div class="rewardsProfile-imageBox">
                                <img :src='ProfileFrame1' class="profile-imgFrame" alt="pf-frame" />
                                <div class="profile-imageBox" v-if="FansRankingWeeklyData.length > 0">
                                    <img class="overlapImg" :src='FansRankingWeeklyData[0].user.profile_images[0].image_name'
                                        alt="User Image" />
                                </div>                                
                            </div>
                            <div class="text-center text-white fansRank_no">No.1</div>
                            <div class="userName-box">
                                <div class="userName" v-if="FansRankingWeeklyData.length > 0">{{ FansRankingWeeklyData[0].user.name }}
                                </div>
                                <div class="beansBox">                                    
                                    <span class="beansValue" v-if="FansRankingWeeklyData.length > 0">
                                        {{ FansRankingWeeklyData[0].total_gift_price }}
                                    </span>
                                    <img :src='diamondIcon' class="diamondIcon" alt="" />
                                </div>
                            </div>
                            <div class="rewards-level" v-if="FansRankingWeeklyData.length > 0">
                                <img :src="getLevelImage(FansRankingWeeklyData[0].user.rich_level)" class="lavelImage" alt="level icon" />
                                <span class="lavel-value">{{ FansRankingWeeklyData[0].user.rich_level }}</span>
                            </div>
                        </div>
                    </div>
                    <div class="position-relative rewardsBox" v-if="FansRankingWeeklyData.length > 2">
                        <img :src='fansRank3_bg' class="fansRank_bgImage fansRank3_bgImage" alt="" />
                        <div class="position-relative rewardsBox-In" @click="redirectProfile(FansRankingWeeklyData[2].user.id, FansRankingWeeklyData[2].user.profile_id, FansRankingWeeklyData[2].user.rich_level)">
                            <div class="rewardsProfile-imageBox">
                                <img :src='ProfileFrame3' class="profile-imgFrame" alt="pf-frame" />
                                <div class="profile-imageBox" v-if="FansRankingWeeklyData.length > 2">
                                    <img class="overlapImg" :src='FansRankingWeeklyData[2].user.profile_images[0].image_name'
                                        alt="User Image" />
                                </div>                                
                            </div>
                            <div class="text-center text-white fansRank_no">No.3</div>
                            <div class="userName-box">
                                <div class="userName" v-if="FansRankingWeeklyData.length > 2">{{ FansRankingWeeklyData[2].user.name }}
                                </div>
                                <div class="beansBox">                                    
                                    <span class="beansValue" v-if="FansRankingWeeklyData.length > 2">
                                        {{ FansRankingWeeklyData[2].total_gift_price }}
                                    </span>
                                    <img :src='diamondIcon' class="diamondIcon" alt="" />
                                </div>
                            </div>
                            <div class="rewards-level" v-if="FansRankingWeeklyData.length > 2">
                                <img :src="getLevelImage(FansRankingWeeklyData[2].user.rich_level)" class="lavelImage" alt="level icon" />
                                <span class="lavel-value">{{ FansRankingWeeklyData[2].user.rich_level }}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="othersAll-listWrapper" v-if="FansRankingWeeklyData.length > 3">
                <div class="fixHeight ringlive-datalistWrap">
                    <div class="listBoxes" v-for="(reward, index) in FansRankingWeeklyData.slice(3) " :key="reward.id"
                    @click="redirectProfile(reward.user.id, reward.user.profile_id, reward.user.rich_level)">
                        <div class="leftBxb">
                            <div class="s-no">{{ index + 4 }}</div>
                            <div class="listIconBox">
                                <div class="profPic">
                                    <img :src='(reward.user.profile_images.length > 0) ? reward.user.profile_images[0].image_name : defaultUserImage'
                                        alt="User Image" />
                                </div>
                            </div>
                            <div class="name-lavel-box">
                                <div class="userName">{{ reward.user.name }}</div>
                                <div class="lavel-box">
                                    <img :src="getLevelImage(reward.user.rich_level)" class="lavelImage" alt="level icon" />
                                    <span class="lavel-value">{{ reward.user.rich_level }}</span>
                                </div>
                            </div>
                        </div>
                        <div class="rightBox">
                            <div class="rightBox-in">                                
                                {{ reward.total_gift_price }}
                                <img :src='diamondIcon' class="diamondIcon" alt="beans icons" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import axios from 'axios'
import ProfileFrame1 from '../../assets/images/rank1-frameImage.png'
import ProfileFrame2 from '../../assets/images/rank2-frameImage.png'
import ProfileFrame3 from '../../assets/images/rank3-frameImage.png'
import diamondIcon from '../../assets/images/diamond-icon.png'
import defaultUserImage from '../../assets/images/default_profile.webp';
import fansRank1_bg from '../../assets/images/fansRanking/fansRank1_bg.webp'
import fansRank2_bg from '../../assets/images/fansRanking/fansRank2_bg.webp'
import fansRank3_bg from '../../assets/images/fansRanking/fansRank3_bg.webp'
import LoadingOverlay from '../LoadingOverlay.vue'
export default {
    name: 'FansRankingAllDataTabCont',
    components: {
        LoadingOverlay
    },
    data() {
        return {
            FansRankingWeeklyData: [],
            // personalDetails: null,
            ProfileFrame1,
            ProfileFrame2,
            ProfileFrame3,
            fansRank1_bg,
            fansRank2_bg,
            fansRank3_bg,
            diamondIcon,
            defaultUserImage,
            loading: false,
            noData: false,
        }
    },
    // watch: {
    //     '$route.params.profile_id': 'fetchFansRankingWeeklyData'
    // },
    mounted() {
        this.profileid = this.$route.params.profileid;
        this.fetchFansRankingWeeklyData();
    },
    methods: {
        fetchFansRankingWeeklyData() {
            this.loading= true;
            const apiUrl = `api/top-contributor-list?type=all&profileid=${this.profileid}`;
            // const tokenParam = this.$route.params.token;
            // const token = tokenParam.split('=')[0];
            // const apiUrl = `api/top-contributor-list?type=all`;
            // axios.get(apiUrl, {
            //     headers: {
            //         'Authorization': `Bearer ${token}`
            //     }
            // })
            axios.get(apiUrl)
                .then(response => {

                    const result = response.data.result;
                    if (!result || result.length === 0) {
                        this.FansRankingWeeklyData = [];
                        this.noData = true;
                    } else {
                        this.FansRankingWeeklyData = result;
                        this.noData = false;
                        this.checkAllImagesExist();
                    }

                    // this.FansRankingWeeklyData = response.data.result;
                    // this.personalDetails = response.data.result.personal_details;
                    // this.checkAllImagesExist();
                })

                .catch(error => {
                    console.error("Error Featching Data", error);
                    this.noData = true;
                })
                .finally(() => {
                    this.loading = false;
                })
        },
        getLevelImage(rich_lavel) {
            switch (true) {
                case rich_lavel === 0:
                    return require('@/assets/images/rich-lavel-0.png');
                case rich_lavel === 1:
                    return require('@/assets/images/rich-lavel-1.png');
                case rich_lavel === 2:
                    return require('@/assets/images/rich-lavel-2.png');
                case rich_lavel === 3:
                    return require('@/assets/images/rich-lavel-3.png');
                case rich_lavel === 4:
                    return require('@/assets/images/rich-lavel-4.png');
                case rich_lavel >= 5 && rich_lavel <= 8:
                    return require('@/assets/images/rich-lavel-5-8.png');
                case rich_lavel >= 9 && rich_lavel <= 11:
                    return require('@/assets/images/rich-lavel-9-11.png');
                case rich_lavel === 12:
                    return require('@/assets/images/rich-lavel-12.png');
                case rich_lavel === 13:
                    return require('@/assets/images/rich-lavel-13.png');
                case rich_lavel === 14:
                    return require('@/assets/images/rich-lavel-14.png');
                case rich_lavel === 15:
                    return require('@/assets/images/rich-lavel-15.png');
                default:
                    return require('@/assets/images/rich-lavel-0.png');
            }
        },
        checkAllImagesExist() {
            this.FansRankingWeeklyData.forEach(reward => {
                if (reward.user.profile_images.length > 0) {
                    const imageUrl = reward.user.profile_images[0].image_name;
                    this.checkImageExists(imageUrl)
                        .then(exists => {
                            if (!exists) {
                                reward.user.profile_images[0].image_name = this.defaultUserImage;
                            }
                        });
                } else {
                    reward.user.profile_images = [{ image_name: this.defaultUserImage }];
                }

                
            });
        },
        checkImageExists(imageUrl) {
            return new Promise((resolve) => {
                var img = new Image();
                img.onload = function () {
                    resolve(true);
                };
                img.onerror = function () {
                    resolve(false);
                };
                img.src = imageUrl;
            });
        },

        setDefaultImage(event) {
            event.target.src = this.defaultUserImage;
        },
        
        redirectProfile(id, profile_id, level) {
            if (window.navigator.userAgent.indexOf("Android") > -1) {
                const baseURL = 'female-weekly-rewards';
                const params = {
                    id: id,
                    profile_id: profile_id,
                    level: level
                };
                const queryString = Object.keys(params)
                    .map(key => `${key}=${params[key]}`)
                    .join('&');
                const url = `${baseURL}?${queryString}`;
                //console.warn(url)
                Android.redirectProfile(url);
            }
        }
    },
}
</script>
<style>
    .no-data-container {
        text-align: center;
        padding: 40px;
        color: #888;
        font-size: 18px;
        }
</style>